export * from "./vendas-por-dia.component";
